import { CommonModule } from '@angular/common';
import { Component, computed, inject, Input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
// import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthService, UserRole } from '../../../core/services/auth.service';

interface menuOptInterface {
  name: string;
  link?: string[];
  queryParams?: Record<string, string>;
  type: 'All' | 'Danger';
  exact: boolean;
  icon: string;
  /** Roles allowed to see this item. Undefined / empty means visible to all authenticated users. */
  roles?: UserRole[];
  subMenuList?: menuOptInterface[];
}

export const menuList: menuOptInterface[] = [
  {
    name: 'Dashboard',
    link: ['/', 'admin'],
    type: 'All',
    exact: true,
    icon: 'assets/svg/widget.svg',
  },
  {
    name: 'Documents',
    link: ['/', 'admin', 'documents'],
    type: 'All',
    exact: false,
    icon: 'assets/svg/documents-minimalistic.svg',
  },
  {
    name: 'Scan',
    link: ['/', 'admin', 'scan'],
    type: 'All',
    exact: false,
    icon: 'assets/svg/scanner.svg',
    roles: [UserRole.SystemAdmin, UserRole.Admin, UserRole.Publisher],
  },
  {
    name: 'Settings',
    type: 'All',
    exact: false,
    icon: 'assets/svg/settings.svg',
    subMenuList: [
      {
        name: 'Users',
        link: ['/', 'admin', 'users'],
        type: 'All',
        exact: false,
        icon: 'assets/svg/users-group.svg',
        roles: [UserRole.SystemAdmin, UserRole.Admin],
      },
      {
        name: 'Departments',
        link: ['/', 'admin', 'departments'],
        type: 'All',
        exact: false,
        icon: 'assets/svg/folder.svg',
        roles: [UserRole.SystemAdmin, UserRole.Admin, UserRole.Librarian],
      },
      {
        name: 'Cabinets',
        link: ['/', 'admin', 'cabinets'],
        type: 'All',
        exact: false,
        icon: 'assets/svg/folder.svg',
        roles: [UserRole.SystemAdmin, UserRole.Admin, UserRole.Librarian],
      },
      {
        name: 'Folders',
        link: ['/', 'admin', 'folders'],
        type: 'All',
        exact: false,
        icon: 'assets/svg/folder.svg',
        roles: [UserRole.SystemAdmin, UserRole.Admin, UserRole.Librarian],
      },
    ],
  },
];

export const menuList2: menuOptInterface[] = [
  {
    name: 'Log Out',
    link: ['/'],
    type: 'Danger',
    exact: true,
    icon: 'assets/svg/logout.svg',
    // isAvailable: ['SuperAdmin', 'admin'],
  },
];

@Component({
  selector: 'app-admin-sidemenu',
  standalone: true,
  imports: [
    SvgIconComponent,
    NzToolTipModule,
    RouterModule,
    // NgScrollbarModule,
    CommonModule,
    NzMenuModule,
  ],
  templateUrl: './admin-sidemenu.component.html',
  styleUrl: './admin-sidemenu.component.less',
})
export class AdminSidemenuComponent {
  authService = inject(AuthService);
  @Input({ required: true }) isCollapsed = false;

  // isSuperAdmin = signal<boolean>(false);
  menuList = computed(() => {
    const role = this.authService.role();

    const isAllowed = (item: menuOptInterface) =>
      !item.roles || item.roles.length === 0 || item.roles.includes(role);

    return menuList
      .filter(isAllowed)
      .map((item) => {
        if (!item.subMenuList) return item;
        const visibleSubs = item.subMenuList.filter(isAllowed);
        if (visibleSubs.length === 0) return null;
        return { ...item, subMenuList: visibleSubs };
      })
      .filter((item): item is menuOptInterface => item !== null);
  });

  menuList2 = signal(menuList2);
}
